import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import SystemModal from "../Common/SystemModal";
import ajaxSuppliers from "../../util/remote/ajaxSuppliers";

const SupplierDetails = ({ SupID }) => {
  const [loading, setLoading] = useState(false);
  const [supplier, setSupplier] = useState(null);

  const fetchSupplierDetails = async () => {
    if (!SupID) return;
    setLoading(true);

    const res = await ajaxSuppliers.fetchSuppliersDetails({ supID: SupID });
    setLoading(false);
    if (res?.status === "OK" && res.details) {
      setSupplier(res.details);
    } else {
      toast.error(res?.message || "Failed to fetch supplier details");
      setSupplier(null);
    }
  };

  useEffect(() => {
    fetchSupplierDetails();
  }, []);

  // Only render modal if SystemModal exists and supplier data is available
  if (!SystemModal) return null;

  const RenderFooter = (controls) => (
    <div className="d-flex justify-content-end">
      <button className="btn btn-dark" type="button" onClick={controls?.close}>
        Close
      </button>
    </div>
  );

  return (
    <SystemModal
      title="Supplier Details"
      id="modal-supplier-details"
      size="lg"
      footer={RenderFooter}
    >
      {loading && (
        <div className="text-center py-5">
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {!loading && supplier && (
        <div className="container-fluid">
          {/* Business Info */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <strong>Business Information</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Business Name:</strong> {supplier.buss_name || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Contact:</strong> {supplier.buss_contact || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Email:</strong> {supplier.buss_email || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>TIN:</strong> {supplier.TIN || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Location:</strong> {supplier.location || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Status:</strong>{" "}
                  {supplier.status === "1" ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-danger">Inactive</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Contact Person */}
          <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light">
              <strong>Contact Person</strong>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6 mb-2">
                  <strong>Name:</strong> {supplier.contact_person || "-"}
                </div>
                <div className="col-md-6 mb-2">
                  <strong>Phone:</strong> {supplier.person_contact || "-"}
                </div>
              </div>
            </div>
          </div>

          {/* Partners */}
          <div className="card shadow-sm">
            <div className="card-header bg-light">
              <strong>Business Partners</strong>
            </div>
            <div className="card-body p-0">
              {supplier.partners?.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Partner Name</th>
                        <th>Contact</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {supplier.partners.map((p, i) => (
                        <tr key={p.id || i}>
                          <td>{i + 1}</td>
                          <td>{p.partner_name || "-"}</td>
                          <td>{p.partner_contact || "-"}</td>
                          <td>
                            {p.created_at
                              ? new Date(p.created_at).toLocaleDateString()
                              : "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-center text-muted py-3 mb-0">
                  No business partners found.
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {!loading && !supplier && (
        <div className="text-center py-5 text-muted">
          No supplier data available.
        </div>
      )}
    </SystemModal>
  );
};

export default SupplierDetails;
